var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow1 = function SvgArrow1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 278 312"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "8 8",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M204.262 281.547c-8.4-5.308-22.588-5.002-31.969-5.141-10.995-.163-21.37 1.802-31.735 5.254-2.489.829-4.995 1.779-7.537 2.432-1.995.513 2.063-4.01 2.73-5.958 9.336-13.119 9.082-16.381 10.888-28.946 2.373-16.516 5.329-25.549 3.636-41.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "6 6",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M71.932 22.01c9.627-4.888 23.637.74 32.978 3.955 14.533 5.004 27.516 12.537 39.252 22.575 22.387 19.15 49.706 48.96 51.685 80.056 2.938 46.187-98.059 25.077-67.828-9.86 12.89-14.897 40.891-8.881 54.919 1.326 22.832 16.614 47.768 35.201 56.338 63.258 10.634 34.812-37.262 71.148-68.204 72.742"
  })));
};
export default SvgArrow1;